module.exports = __webpack_public_path__ + "img/authenticator_google.8d29182c.png";